import _merge from 'lodash/merge';

import { planKeys } from 'config/planKeys';

/* 大部分直接使用 plan key value
 * 其他常數的 key 值 則是前端自用的（大多依賴 partner / sponsor 的設定做判斷）
 */
export const functionKeys = _merge({}, planKeys, {
    loginQualify: {
        line: { ADD_FRIEND: 'LINE_ADD_FRIEND', BIND_MEMBER_ACCOUNT: 'LINE_BIND_MEMBER_ACCOUNT' },
        CYBERBIZ_EC_MEMBER: 'CYBERBIZ_EC_MEMBER',
        NEW_REGISTER_MEMBER: 'NEW_REGISTER_MEMBER',
        APP_LOGIN: 'APP_LOGIN'
    },
    qualify: {
        nameList: {
            API: 'QUALIFY_NAME_LIST_API'
        },
        MEMBER_ORDER: 'QUALIFY_MEMBER_ORDER'
    },
    point: {
        REDUCE_POINT: 'QUALIFY_REDUCE_POINT'
    },
    prizeTypes: {
        CASH_VOUCHER: 'CASH_VOUCHER',
        POINT: 'POINT',
        PROMO_POINT: 'PROMO_POINT', // 活動點數 (動態 & 固定)
        PRIZE_CODE: 'PRIZE_CODE',
        CYBERBIZ_COUPON: 'CYBERBIZ_COUPON',
        SHOPLINE_COUPON_CODE: 'SHOPLINE_COUPON_CODE'
    }
});

export const partnerDisplayKeys = {
    DISPLAY_LOGIN: 'displayLoginType',
    DISPLAY_PLAY_TIMES: 'displayPlayTimes',
    DISPLAY_LOTTERIES: 'displayLotteries'
};

export const functionKeysMappingDisplayType = [
    [functionKeys.login, partnerDisplayKeys.DISPLAY_LOGIN],
    [functionKeys.lotteries, partnerDisplayKeys.DISPLAY_LOTTERIES],
    [functionKeys.entries, partnerDisplayKeys.DISPLAY_PLAY_TIMES]
].reduce((obj, [settingKeysGroup, displayKey]) => {
    Object.entries(settingKeysGroup).forEach(([, val]) => (obj[val] = displayKey));
    return obj;
}, {});

// 此 value 跟 promo setting 的  redeemPointType 的 value 一樣，負責控制現在是會員點數(一般會員點數/kk point) or 活動點數 被綁定
export const bindingPointPoolKeys = {
    PROMO_POINT: 'PromotionPoint',
    MEMBER_POINT: 'MemberPoint',
    KK_POINT: 'kkPoint'
};
